import NegotiationList, {
  NegotiationRow,
} from '../shared/NegotiationList';
import { firstNumber, firstText } from '../shared/records';

export type ActiveAgreement = NegotiationRow;

const toAgreement = (item: Record<string, unknown>): ActiveAgreement => ({
  idNegociacao: firstText(item.idNegociacao, item.id),
  nome: firstText(item.nome, item.nomeCliente),
  cpf: firstText(item.cpf, item.cpfCliente).replace(/\D/g, ''),
  data: firstText(item.data, item.dataNegociacao, item.dataCriacao, item.dataAcordo),
  valorOriginal: firstNumber(item.valorOriginal),
  desconto: firstNumber(item.desconto, item.valorDesconto),
  entrada: firstNumber(item.entrada, item.valorEntrada, item.valorComDesconto),
  parcelas: firstNumber(item.parcelas, item.quantidadeParcelas, item.numeroParcelas),
  vencimento: firstText(item.vencimento, item.dataVencimento),
  status: firstText(item.status),
  operador: firstText(item.operador, item.nomeOperador, item.cpfOperador),
});

const DebtNegotiationActiveAgreements = (): JSX.Element => (
  <NegotiationList
    status="ATIVA"
    detailPath="/negociacao-dividas/acordos-ativos/detalhes"
    emptyMessage="Nenhum acordo ativo encontrado."
    errorMessage="Não foi possível consultar os acordos ativos."
    mapItem={toAgreement}
  />
);

export default DebtNegotiationActiveAgreements;
